// ** React Imports
import React from "react";

// ** Third Party Components
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

// ** Custom Components
import Block from "components/layout/Block";
import Text from "components/typography/Text";

// ** Datainfo Components
import DataPreferences from "./DataInfo/components/DataPreferences";
import DataInterests from "./DataInfo/components/DataInterests";

// #####################################################

const PreferencesInfo = ({ user, isSearchVisible }) => {
	const { t } = useTranslation([
		"common",
		"filtersAndSelectors",
		"userProfile",
	]);
	const isNewPreferences = useSelector(
		(state) => state.globalCommon.isNewPreferences
	);
	// #####################################################

	return (
		<>
			<Block
				pt={
					!user.description?.plain &&
					!isSearchVisible &&
					user?.listOfLinksArray?.length === 0
						? 0
						: 6
				}
			>
				<Text bold size="1.25rem">
					{t("filtersAndSelectors:preferencesLabel")}
				</Text>
			</Block>
			<Block>
				<DataPreferences isNewPreferences={isNewPreferences} />
				{!isNewPreferences && <DataInterests />}
			</Block>
		</>
	);
};

// #####################################################

export default PreferencesInfo;

// #####################################################
